import React from 'react'

interface Props {
  children?: React.ReactNode,
  customStyle?: React.CSSProperties,
  [other: string]: any,
}

const Wrapper: React.FC<Props> = ({
  children = null,
  customStyle = {},
  ...other
}) => (
  <div {...other} style={customStyle}>
    <>{ children }</>
  </div>
)

export default Wrapper
